export const AuthRecursosDigitals = ({ auth, handleChange, error, edat }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Autorització per a l’ús de serveis i recursos digitals a Internet per treballar a l'aula
        </h4>
        <p>

          Per al treball acadèmic de les diferents matèries els alumnes han d'utilitzar diverses eines informàtiques i, en especial, aquelles relacionades amb la transmissió d’informació a traves d'Internet: correu electrònic, creació de blogs opàgines web, etc.<br />
          <br />

          Per tal de treballar aquests continguts el centre crearà un compte personal de Google Apps per cada membre de l'alumnat.<br />
          <br />

          El compte tindrà el format usuari@insjaumemimo.cat i permetrà fer diferents tasques relacionades amb el currículum. Aquest compte serà d'us exclusivament acadèmic, de manera que l'alumnat no haurien d'utilitzar-lo dins del seu àmbit personal.<br />
          <br />

          En algun cas també poden tenir accés a cursos d'alguna matèria en la plataforma Moodle del centre. D'altra banda, si en alguna matèria s’utilitzés llibres digitals, caldria que la corresponent editorial creessin els comptes a instància del centre.<br />
          <br />
          La normativa del Departament d'Educació marca que per als menors de 14 anys es necessari el permís per escrit dels pares o tutors, mentre que si l'alumne es major de 14 anys, només cal informar els pares o tutors<br />
          <br />

          <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authRecursosDigitals">

            {edat < 14 ?
              "Autoritzo que el centre gestioni la creació de l’usuari i contrasenya associats als següents recursos i serveis d’Internet:"
              :
              "Declaro que estic assabentat/ada que el centre gestionarà la creació de l’usuari i contrasenya associats als següents cursos i serveis d’Internet:"
            }

            <br /> Google Apps per a Educació, plataforma Moodle i si s’escau, llibres de text digitals per al treball acadèmic amb finalitat pedagògiques. <br />

          </label>
          <span id="auhtRecursosDigitals_ERROR" className="a-Form-error">{error}</span>
        </p>

        <p>
          La gestió d'aquests identificadors i la responsabilitat de l’ús que se'n faci en l'àmbit escolar correspon al
          centre educatiu. Aquest no es fa responsable de l’ús indegut del recurs i dels seus continguts per part dels
          usuaris. L'usuari serà únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui
          causar per un us inadequat dels seus serveis o dels seus continguts.
        </p>

      </div>
    </div>


    <br />
  </>)
}
